export const siMISCELLANEOUS = 'MISCELLANEOUS'
export const si7501 = '7501'
export const siBROKER_INVOICE = 'BROKER_INVOICE'
export const siBOND_RELEASE = 'BOND_RELEASE'
export const siCAN_OWNERSHIP_ONTARIO = 'CAN_OWNERSHIP_ONTARIO'
export const siCAN_OWNERSHIP_QUEBEC = 'CAN_OWNERSHIP_QUEBEC'
export const siMICHIGAN_TITLE = 'MICHIGAN_TITLE'
export const siMICHIGAN_TITLE_APPLICATION_RECEIPT = 'MICHIGAN_TITLE_APPLICATION_RECEIPT'
export const siOHIO_TITLE = 'OHIO_TITLE'
export const siSIGNED_STATEMENT_OF_CONFORMITY = 'SIGNED_STATEMENT_OF_CONFORMITY'
export const siSIGNED_OUTBOUND_BOL = 'SIGNED_OUTBOUND_BOL'

export const CAN_OWNERSHIP_ONTARIO_SMALL = 'CAN_OWNERSHIP_ONTARIO_SMALL'
export const CAN_OWNERSHIP_ONTARIO_MEDIUM = 'CAN_OWNERSHIP_ONTARIO_MEDIUM'
export const CAN_OWNERSHIP_ONTARIO_LARGE = 'CAN_OWNERSHIP_ONTARIO_LARGE'
